import axios, { type AxiosError, type AxiosRequestConfig } from 'axios';

/** Corps JSON renvoyé par le proxy Vite quand Nest est injoignable (voir `apps/web/vite.config.ts`). */
export type ApiProxyUnavailableBody = {
  error: 'API_UNAVAILABLE';
  message: string;
};

export function isApiProxyUnavailableError(
  err: unknown,
): err is AxiosError<ApiProxyUnavailableBody> {
  if (!axios.isAxiosError(err) || err.response?.status !== 503) return false;
  const data = err.response?.data as { error?: string } | undefined;
  return data?.error === 'API_UNAVAILABLE';
}

export function getApiProxyUnavailableMessage(err: unknown): string | null {
  if (!isApiProxyUnavailableError(err)) return null;
  const m = err.response?.data?.message;
  return typeof m === 'string' && m.length > 0 ? m : null;
}

export const apiAxiosInstance = axios.create({
  baseURL: typeof window !== 'undefined' ? '' : 'http://localhost:3000',
  withCredentials: true,
});

export const apiAxios = <T>(config: AxiosRequestConfig): Promise<T> =>
  apiAxiosInstance.request<T>(config).then((res) => res.data);

export const setApiBaseUrl = (baseUrl: string): void => {
  apiAxiosInstance.defaults.baseURL = baseUrl;
};

export const setAuthToken = (token: string | null): void => {
  if (token) {
    apiAxiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    // biome-ignore lint/performance/noDelete: removing the header entirely is the intended axios pattern; assigning undefined would still serialize the key.
    delete apiAxiosInstance.defaults.headers.common.Authorization;
  }
};
